var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBlogger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f2f2",
    d: "M15.52 34a9.42 9.42 0 0 1-9.42-9.42v-9.29A9.29 9.29 0 0 1 15.38 6h4.93c4.16 0 8.23 3.61 8.23 7v1.45a2.34 2.34 0 0 0 2.34 2.34h1.46a1.56 1.56 0 0 1 1.56 1.56v6.5A9.11 9.11 0 0 1 24.79 34Zm6.38-18.93a1.75 1.75 0 0 0-1.75-1.75h-5.27a1.75 1.75 0 0 0-1.76 1.75 1.76 1.76 0 0 0 1.76 1.76h5.27a1.75 1.75 0 0 0 1.75-1.76ZM27 25a1.75 1.75 0 0 0-1.76-1.75H14.88A1.75 1.75 0 0 0 13.12 25a1.76 1.76 0 0 0 1.76 1.76h10.34A1.76 1.76 0 0 0 27 25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlogger);
export default __webpack_public_path__ + "static/media/icon-blogger.a2279d7822fa0e7c34946ff966873fc2.svg";
export { ForwardRef as ReactComponent };